import React from "react";
import { NoItems } from "components/Deal/DealDetailsSections/util";

import { formatLabel } from "./DealLabel";

const EmptyDeals = ({ status }) => (
  <div style={{ marginTop: "17px", marginBottom: "17px" }}>
    <NoItems Message={`There are no ${formatLabel(status).lower} on this Group.`} />
  </div>
);

export default EmptyDeals;
